import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import * as actionTypes from 'modules/interventions/actionTypes';

import defaultChecklistGroupId from './defaultChecklistGroupId';
import isOpen from './isOpen';

/**
 * @typedef {{
 *  isOpen: import('./isOpen').IsOpenState,
 * }} ChecklistState
 */

export default combineReducers({
  isOpen,
  isLoading: loading(actionTypes.IMPORT_CHECKLISTS),
  defaultChecklistGroupId,
});
